import { reaction } from 'mobx';
import { types } from 'mobx-state-tree';
import PubSub from 'pubsub-js';
import keyboardjs from 'keyboardjs';

import { getWindowSize } from 'js/services/ResizeListener';
import { castEventToValue } from 'js/services/FormTools';
import WindowSize from './types/WindowSize';

const largestPanelSize = 500;
const gutterSize = 75;

function shouldShowAssertion(shouldShow, navigation) {
  return shouldShow && navigation.windowSize.height < navigation.contentHeight ? 'open' : 'closed';
}

export default types
  .model('NavigationState', {
    contentHeight: 0,
    isOpen: false,
    windowSize: types.optional(WindowSize, {}),
  })
  .views(self => ({
    get panelSize() {
      return self.windowSize.width - gutterSize < largestPanelSize
        ? self.windowSize.width - gutterSize
        : largestPanelSize;
    },
  }))
  .actions(self => {
    let pageBootListener;
    let windowResizeListener;
    let scrollbarReactionDisposer;
    return {
      afterCreate() {
        scrollbarReactionDisposer = reaction(() => shouldShowAssertion(self.isOpen, self), self.updateVisibility);
        keyboardjs.bind('esc', self.close);
        windowResizeListener = PubSub.subscribe('onResize', (msg, windowSize) => self.setWindowSize(windowSize));
        pageBootListener = PubSub.subscribe('page-booting', self.close);
        self.setWindowSize();
      },
      beforeDestroy() {
        scrollbarReactionDisposer();
        keyboardjs.unbind('esc', self.close);
        PubSub.unsubscribe(windowResizeListener);
        PubSub.unsubscribe(pageBootListener);
      },
      close(event) {
        event && event.stopPropagation && event.stopPropagation();
        self.isOpen = false;
        return self;
      },
      setContentHeight(contentHeight) {
        self.contentHeight = castEventToValue(contentHeight);
        return self.updateVisibility(shouldShowAssertion(self.isOpen, self));
      },
      toggle(event) {
        event && event.stopPropagation && event.stopPropagation();
        self.isOpen = !self.isOpen;
        return self;
      },
      setWindowSize(windowSize) {
        self.windowSize = windowSize || getWindowSize();
        return self.updateVisibility(shouldShowAssertion(self.isOpen, self));
      },
      updateVisibility(visible) {
        if (visible === 'open') {
          document.documentElement.classList.add('modalIsOpen');
        } else {
          document.documentElement.classList.remove('modalIsOpen');
        }
        return self;
      },
    };
  });
